<template>
  <div class="game-builder-sidebar">
    <b-card>
      <h6 class="mb-1">
        Прогресс: {{ completedCount }}/{{ totalCount }}
      </h6>
      <b-progress
        :value="completedCount"
        :max="totalCount"
        variant="success"
        class="mb-2"
      />

      <div
        v-for="round in gameData.rounds"
        :key="round.id"
        class="mb-1"
      >
        <h6 class="mb-50">
          {{ round.name || `Раунд ${round.number}` }}
        </h6>
        <div class="d-flex flex-wrap" style="gap: 4px">
          <div
            v-for="rt in round.topics"
            :key="rt.id"
            :title="rt.autotopic_title || rt.topic_name || 'Пусто'"
            class="progress-dot"
            :class="{
              'dot-complete': isRtComplete(rt),
              'dot-current': rt.id === currentRtId,
              'dot-empty': !isRtComplete(rt) && rt.id !== currentRtId,
            }"
          >
            {{ questionsLabel(rt) }}
          </div>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import { BCard, BProgress } from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BProgress,
  },
  props: {
    gameData: {
      type: Object,
      required: true,
    },
    currentRtId: {
      type: [Number, null],
      default: null,
    },
  },
  setup(props) {
    const isRtComplete = rt => {
      if (!rt.autotopic_id) return false
      const required = rt.required_questions || 5
      return (rt.questions?.length || 0) >= required
    }

    const computeCounts = () => {
      let completed = 0
      let total = 0
      if (props.gameData && props.gameData.rounds) {
        props.gameData.rounds.forEach(round => {
          if (round.topics) {
            round.topics.forEach(rt => {
              total += 1
              if (isRtComplete(rt)) completed += 1
            })
          }
        })
      }
      return { completed, total }
    }

    const questionsLabel = rt => {
      const count = rt.questions?.length || 0
      const required = rt.required_questions || 5
      return `${count}/${required}`
    }

    return {
      isRtComplete,
      computeCounts,
      questionsLabel,
    }
  },
  computed: {
    completedCount() {
      return this.computeCounts().completed
    },
    totalCount() {
      return this.computeCounts().total
    },
  },
}
</script>

<style scoped>
.progress-dot {
  min-width: 28px;
  height: 18px;
  border-radius: 3px;
  cursor: default;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 600;
  color: #fff;
  padding: 0 3px;
}

.dot-complete {
  background-color: #28c76f;
}

.dot-current {
  background-color: #7367f0;
  box-shadow: 0 0 6px rgba(115, 103, 240, 0.6);
}

.dot-empty {
  background-color: #d6d6d6;
}
</style>
